import { render, staticRenderFns } from "./AddOrUpdateDistrictForm.vue?vue&type=template&id=311a6a72"
import script from "./AddOrUpdateDistrictForm.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateDistrictForm.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateDistrictForm.vue?vue&type=style&index=0&id=311a6a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports